export class ClientInfo {
    thumbprint: string;
}
